import { useCallback, useEffect, useState } from "react";

import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import useService from "../../../../../hooks/useService";
import { getModalHandler } from "../../../Common/Modals/hooks/useModalSingleton";

export function useProviderServicesPermissions() {
  const { id } = useParentLoaderData(2);
  const currentUserService = inject("current-user-service");
  const providerRepository = useService("repositories/provider-repository");
  const { _, openFailureModal } = getModalHandler();

  const permissions = currentUserService?.userRoles?.permissions ?? [];
  const canAddProviderServices = permissions.includes("provider.add_providerservice");
  const canDeleteProviderServices = permissions.includes("provider.delete_providerservice");

  const [managedProviderId, setManagedProviderId] = useState(null);

  const userId = currentUserService.user?.pk || currentUserService.user?.id;

  const fetchManagedProviderId = useCallback(
    async (userId) => {
      try {
        if (!userId) {
          return null;
        }
        const response = await providerRepository.getManagedProvider(userId);
        return response?.id ?? null;
      } catch (error) {
        console.error(error);
        openFailureModal(error);
        return null;
      }
    },
    [providerRepository]
  );

  useEffect(() => {
    let isMounted = true;

    fetchManagedProviderId(userId).then((id) => {
      if (isMounted) {
        setManagedProviderId(id);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [userId]);

  const canEditProviderServices =
    currentUserService.user?.entity &&
    currentUserService.user.entity.entity_type_label === "Provider" &&
    id !== managedProviderId
      ? canAddProviderServices || canDeleteProviderServices
      : false;

  return {
    canAddProviderServices,
    canDeleteProviderServices,
    canEditProviderServices,
  };
}
